// Conversions between the live FrmVar model vars and their serialized wire forms,
// and the opening-derived identity / dimension snapshots. See
// ../data-json-dtos.md for the classification.

import {FrmVar} from "../drawfrm/FrmVar";
import {inches} from "../const";
import {Opening} from "../../../../../api/Openings";
import {SerFrmVar, SerScalarVar, ElevationIdentity, DimensionFingerprint} from "../../../../../api/elevationTool/shared";

// serialize a distance FrmVar: value in inches (decoupled from the `inches` scale),
// plus the modified flag when set.
export function serFrmVar(v: FrmVar): SerFrmVar {
    const out: SerFrmVar = {in: v.get() / inches};
    if(v.isModified()) out.mod = true;
    return out;
}

// restore a distance FrmVar in place from its wire form.
export function restoreFrmVar(v: FrmVar, s: SerFrmVar) {
    v.restore(s.in * inches, !!s.mod);
}

// serialize a non-distance (count/ratio) FrmVar — not inches-scaled.
export function serScalar(v: FrmVar): SerScalarVar {
    const out: SerScalarVar = {value: v.get()};
    if(v.isModified()) out.mod = true;
    return out;
}

// restore a non-distance FrmVar in place from its wire form.
export function restoreScalar(v: FrmVar, s: SerScalarVar) {
    v.restore(s.value, !!s.mod);
}

// the five Synced identity props, read from the (kept-in-sync) opening row.
export function identityFromOpening(opening: Opening): ElevationIdentity {
    return {
        openingType: opening.openingType,
        frameProfile: opening.frameProfile,
        handing: opening.handing,
        flipDoubleActiveHanding: opening.flipDoubleActiveHanding,
        locationTransition: opening.locationTransition,
    };
}

// the per-opening dimensions the design was built against, for drift detection.
export function dimensionFingerprintFromOpening(opening: Opening): DimensionFingerprint {
    return {
        nominalWidth: opening.nominalWidth,
        inactiveDoorWidth: opening.inactiveDoorWidth,
        nominalHeight: opening.nominalHeight,
        jambDepth: opening.jambDepth,
        doorThickness: opening.doorThickness,
    };
}
